module.exports = __webpack_public_path__ + "scripts/outline-icons.woff2?7980a636";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/outline-icons.woff2
// module id = 946
// module chunks = 1